/**
 * Scripts for modals
 * Should be included at the end of the body so all the content 
 * is loaded to attach the event handlers to.
 */

/**
 * Checks if the url hash corresponds to a dialog element and opens it if applicable
 * @param {string} hash 
 */
function openModalByHash(hash) {

	// If the hash is empty close all open dialogs and return
	if (hash === '') {
		console.log('empty hash');
		document.querySelectorAll("dialog").forEach((dialog) => {
			if (dialog.open) dialog.close();
		});

		return;
	}

	// See if the hash matches a dom element
	let element = document.getElementById(hash.substring(1));
	
	if (element === null) return;
	
	// If the hash matches a dialog id, open it
	if (element.tagName === 'DIALOG') {
		element.showModal();
	}
}

// Onload if we're looking for a modal, open it up
if (window.location.hash) {
	openModalByHash(window.location.hash);
}

// Watch for the location hash to change and see if we need to do anything with modals
window.addEventListener('hashchange', () => {
	openModalByHash(window.location.hash);
}, false);

// Add a listener for the close events of modals and go back to the current page path
document.querySelectorAll("dialog").forEach((dialog) => {
	dialog.addEventListener("close", (e) => {
		if (dialog.id === window.location.hash.substring(1)) {
			window.history.pushState({}, '', window.location.pathname);
		}
	}); 
});



// Size Guide Modal
function openSizeGuide() {
	document.getElementById('sizeGuideModal').style.display = 'block';
	document.body.style.overflow = 'hidden';
}

function closeSizeGuide() {
	document.getElementById('sizeGuideModal').style.display = 'none';
	document.body.style.overflow = 'auto';
}

// Make functions globally accessible
window.openSizeGuide = openSizeGuide;
window.closeSizeGuide = closeSizeGuide;

// Close modal when clicking outside of it
window.onclick = function (event) {
	var modal = document.getElementById('sizeGuideModal');
	if (event.target == modal) {
		closeSizeGuide();
	}
}

// Close modal with Escape key
document.addEventListener('keydown', function (event) {
	if (event.key === 'Escape') {
		closeSizeGuide();
	}
});